import { Label } from './component.styles'
export default Label
